import React, { Fragment, useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useMenu } from 'config/menu';
import { Picture } from 'components-guide';
import { NavDesktop, NavMobile, NavButton, NavSearchMobile } from './components';
import Router from 'router';
import Info from 'config/info';
import Config from 'config';

import './TheNav.scss';
export interface TheNavProps {
    /**
     * Invert color
     */
    invert?: boolean;
    /**
     * Translate prop
     */
    t: any;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
}

const getLogo = ({ invert, isMobile }: any) => {
    const type = isMobile ? 'mobile' : 'desktop';
    return invert ? Info.logos[type].invert : Info.logos[type].default;
};

const TheNav: React.FC<TheNavProps> = ({ invert = false, t, className, style }) => {
    const [mobile, setMobile] = useState(false);
    const [logo, setLogo] = useState('');
    const isMobile = useMediaQuery({ query: '(max-width: 992px)' });
    const links = useMenu({ t });

    useEffect(() => {
        setLogo(getLogo({ invert, isMobile }));
    }, [invert, isMobile]);

    const handleToggle = () => setMobile(!mobile);
    const handleOnClickItem = ({ href, params }: any) => {
        if (isMobile) setMobile(!mobile);
        if (href) Router.push({ pathname: href, query: params });
    };
    const handleOnClickBecomeCustomer = () => Router.push({ pathname: Info.urls.openAccount });
    const handleOnClickSubscribe = () => {
        // Open subscription modal by triggering a custom event
        const event = new Event('openSubscriptionModal');
        document.dispatchEvent(event);
    };

    const common = {
        links,
        t,
        onClickItem: handleOnClickItem,
        onClickBecomeCustomer: handleOnClickBecomeCustomer,
        onClickSubscribe: handleOnClickSubscribe,
    };

    return (
        <Fragment>
            {isMobile ? (
                <div className="the-nav__mobile flex row-stretch-center">
                    <div>
                        <a href="/" tabIndex={0}>
                            <Picture src={`${Config.themePath}${logo}`} alt="MyInvestor" className="logo" />
                        </a>
                    </div>
                    <NavSearchMobile invert={invert} t={t} />
                    <NavButton invert={invert} active={mobile} onClick={handleToggle} />
                </div>
            ) : null}
            <NavMobile active={mobile && isMobile} {...common} />
            <NavDesktop invert={invert} {...common} />
        </Fragment>
    );
};

export default TheNav;
